import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesCrossFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 12C1 3.25 2.375 2 12 2s11 1.25 11 10q0 .784-.016 1.489a6.8 6.8 0 0 0-10.09 8.507Q12.459 22 12 22C2.375 22 1 20.75 1 12m5-4.9v1.8h12V7.1zm0 5.8h6v-1.8H6z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10m-2.758-6.485L17.727 19l-1.485 1.485 1.273 1.273L19 20.273l1.485 1.485 1.273-1.273L20.273 19l1.485-1.485-1.273-1.273L19 17.727l-1.485-1.485z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CardLinesCrossFilledSize24Glyph.displayName = 'CardLinesCrossFilledSize24Glyph';
